// @ts-nocheck
import { AppShell, Box, Divider, Group, rem, Stack, Text } from "@mantine/core";
import { useHeadroom } from "@mantine/hooks";
import { useDrag } from "@use-gesture/react";
import { observer } from "mobx-react-lite";
import Logo from "@/components/common/Logo";
import { ButtonBurguer } from "@/components/common/ui/button/ButtonBurger/ButtonBurguer";
import { ButtonBurguerThumb } from "@/components/common/ui/button/ButtonBurger/ButtonBurguerThumb";
import { crewStore, uiStore, userStore } from "@/mobx/rootStore";
import { useAppSizeId } from "@/utils/hooks/useAppSizeId";
import { version } from "../../../package.json";
import classes from "./PrivateLayout.module.css";
import AppSelector from "./partials/AppSelector";
import CrewSelector from "./partials/CrewSelector";
import UserInfo from "./partials/UserInfo";

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 */
export default observer(function PrivateLayout({ children }) {
	const pinned = useHeadroom({ fixedAt: 120 });
	const { isMobile } = useAppSizeId();

	const optThumbBurger = userStore.getSetting("opt_thumbBurger");
	const opt_groupShortcut = userStore.getSetting("opt_groupShortcut");

	const bind = useDrag(
		({ swipe, tap }) => {
			if (tap) {
				return;
			}

			const swipeX = swipe[0]; // position will either be -1, 0 or 1

			if (swipeX === 0) {
				return;
			}
			if (swipeX === -1) {
				uiStore.closeMobileNavbar();
			}
			if (swipeX === 1) {
				uiStore.openMobileNavbar();
			}
		},
		{
			filterTaps: true,
			axis: "x",
			swipe: {
				distance: 20,
				velocity: 1,
				duration: 1500,
			},
		},
	);

	const thumbBurgerStyle = {
		left: {
			bottom: "var(--mantine-spacing-xxs)",
			left: "var(--mantine-spacing-sm)",
		},
		right: {
			bottom: "var(--mantine-spacing-xxs)",
			right: "var(--mantine-spacing-sm)",
		},
	}[optThumbBurger];

	const hasCrews = crewStore.hasCrews();

	const isOpened = uiStore.getIsNavbarOpened();

	const shouldShowThumbBurger =
		optThumbBurger !== "hidden" && (isOpened || optThumbBurger === "right");

	return (
		<AppShell
			padding="md"
			header={{
				height: 60,
				collapsed: !isOpened && !pinned,
				offset: true,
			}}
			navbar={{
				width: 300,
				breakpoint: "sm",
				collapsed: { mobile: !isOpened, desktop: !isOpened },
			}}
			className={classes.appShell}
			{...bind()}
			data-swipe-action="openMenu"
		>
			<AppShell.Header>
				<Group h="100%" w="100%" px="md" wrap="nowrap">
					<ButtonBurguer opened={isOpened} onClick={() => uiStore.toggleNavbar()} />

					{(isOpened || !isMobile) && (
						<>
							<Group gap="xs">
								<Logo />

								<Text size="lg" fw="bold">
									Economos
								</Text>
							</Group>

							<Text size="sm" c="dimmed">
								{version}
							</Text>
						</>
					)}

					{isMobile
						&& !uiStore.getIsNavbarOpened()
						&& opt_groupShortcut === "visible" && <CrewSelector variant="mobile" />}
				</Group>
			</AppShell.Header>

			<AppShell.Navbar p="md">
				<Stack gap="xl" justify="space-between" h={"100%"} data-swipe-action="closeMenu">
					<Stack>
						<CrewSelector />
						<Divider />
						{hasCrews && <AppSelector closeMobileFnc={uiStore.closeNavbar} />}
					</Stack>

					<Stack>
						<Divider />

						<UserInfo />

						<Divider />

						<Box pl="xs">
							<ButtonBurguer
								opened={isOpened}
								onClick={() => uiStore.toggleNavbar()}
								text="Cerrar menú"
							/>
						</Box>
					</Stack>
				</Stack>
			</AppShell.Navbar>

			<div className={classes.thumbBurgerContainer} style={thumbBurgerStyle}>
				{shouldShowThumbBurger && (
					<ButtonBurguerThumb opened={isOpened} onClick={() => uiStore.toggleNavbar()} />
				)}
			</div>

			<AppShell.Main pt={`calc(${rem(60)} + var(--mantine-spacing-md))`}>
				{children}
			</AppShell.Main>
		</AppShell>
	);
});
